import { render } from "./warehouse-details.vue?vue&type=template&id=13ebd102"
import script from "./warehouse-details.vue?vue&type=script&lang=js"
export * from "./warehouse-details.vue?vue&type=script&lang=js"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__